<template>
<div>
	<Page v-for="(page, i) in pages" :key='i' :class="{
				'Page--continuing': i < pages.length - 1 && !page.table
			}">
		<div v-if="i===0" class="Proposal-Info">
			<span class="Proposal-Info--Number">{{proposal['Type']}} Nr. {{proposal['Project-Number']}}</span>
			<span class="Proposal-Info--Date">vom {{proposal['Date']}}</span>
		</div>

		<div v-if="page.phases && page.phases.length" class="Milestones" :class="{'Milestones--noTime': proposal.milestones['Time'] == 0}">
			<div v-if="i===0" class="Header">
				<span>Leistungen/ Phase</span>
				<span>Kosten</span>
				<span v-if="proposal.milestones && proposal.milestones['Time']!==0">Zeitraum</span>
			</div>
			<ul class="Milestones-Tree" ref="milestonesTree">
				<Phase v-for="(milestone, i) in page.phases" :key='i' :itemValues="milestone.values" :milestones="proposal.milestones" :class="{
					'Phase--noName' : milestone.fromPrev
				}">
					<FirstLayer v-for="firstLayer in milestone.children" :key="firstLayer.id" :itemValues="firstLayer.values">
						<SecondLayer v-for="secondLayer in firstLayer.children" :key="secondLayer.id" :itemValues="secondLayer.values">
							<ThirdLayer v-for="thirdLayer in secondLayer.children" :key="thirdLayer.id" :itemValues="thirdLayer.values">
							</ThirdLayer>
						</SecondLayer>
					</FirstLayer>
				</Phase>
			</ul>
		</div>


		<PriceTable v-if="page.table && page.phases && page.phases.length" :milestones="proposal.milestones" />

		<div v-if="page.optionalPhases && page.optionalPhases.length" class="Milestones Milestones--optional" :class="{'Milestones--noTime': !proposal.milestones['Time-Optional']}">
			<div v-if="i === optionalPageNum" class="Proposal-Info">
				<span class="Proposal-Info--Number">Optionale Posten</span>
			</div>
			<ul class="Milestones-Tree" ref="milestonesTree">
				<Phase v-for="(milestone, i) in page.optionalPhases" :key='i' :itemValues="milestone.values" :milestones="proposal.milestones" :class="{
					'Phase--noName' : milestone.fromPrev
				}">
					<FirstLayer v-for="firstLayer in milestone.children" :key="firstLayer.id" :itemValues="firstLayer.values">
						<SecondLayer v-for="secondLayer in firstLayer.children" :key="secondLayer.id" :itemValues="secondLayer.values">
							<ThirdLayer v-for="thirdLayer in secondLayer.children" :key="thirdLayer.id" :itemValues="thirdLayer.values">
							</ThirdLayer>
						</SecondLayer>
					</FirstLayer>
				</Phase>
			</ul>
		</div>
	</Page>
</div>
</template>



<script>
import Page from './Page.vue';
import PriceTable from './PriceTable.vue';
import Phase from './Phase.vue';
import FirstLayer from './FirstLayer.vue';
import SecondLayer from './SecondLayer.vue';
import ThirdLayer from './ThirdLayer.vue';

export default {
	name: 'Milestones',
	components: {
		Page,
		PriceTable,
		Phase,
		FirstLayer,
		SecondLayer,
		ThirdLayer,
	},
	props: {
		proposal: {
			type: Object,
			default () {
				return null
			}
		}
	},

	data() {
		return {
			milestones: this.proposal.milestones || {},
			pages: [],
			pageNum: 0,
			optionalPageNum: -1,
		}
	},
	created() {

	},
	watch: {
		proposal: function (val) {
			console.log('Milestones got updated');
			this.milestones = val.milestones;
			this.structureMilestones(this.milestones);
		}
	},
	computed: {

	},
	methods: {
		// divide into "normal" and optional phases and set pages' structure
		structureMilestones(milestones) {
			try {
				let allPhases = milestones.items || [];
				let counter = 0;
				let counterOpt = 0;

				let phases = [[]];
				let optionalPhases = [[]];
				this.pages = [];
				this.optionalPageNum = -1;

				for (let milestone of allPhases) {
					if (milestone.values.optional) {
						// if there should be a page break before Optional Phases
						if (optionalPhases.length === 1 && !optionalPhases[0].length && milestone.values.pageBreak) {
							this.optionalPageNum += 1;
						}
						this.pushPhases(milestone, optionalPhases, counterOpt);
						if (milestone.values.pageBreak) counterOpt++;
					} else {
						this.pushPhases(milestone, phases, counter);
						if (milestone.values.pageBreak) counter++;
					}

					// if milestone has page break INSIDE children
					if (milestone.children) {
						for (let child of milestone.children) {
							if (child.values.pageBreak) {
								if (milestone.values.optional) {
									counterOpt++;
									this.pushPhases(milestone, optionalPhases, counterOpt, true);
								} else {
									counter++;
									this.pushPhases(milestone, phases, counter, true);
								}
								break;
							}
						}
					}
				}

				this.optionalPageNum += phases.length;
				this.definePages(phases, optionalPhases);

			} catch (e) {
				console.log(e);
			}
		},

		// save milestone to pages (array of arrays)
		pushPhases(milestone, phases, counter, pageBreakInside = false) {
			// if pagebreak set, create new array inside pages and push following pages there
			if (milestone.values.pageBreak || pageBreakInside) {
				let arr = [];

				if (pageBreakInside) {
					// make a copy of milestone for the next page
					const milestoneCopy = JSON.parse(JSON.stringify(milestone));
					milestoneCopy.fromPrev = true;
					arr.push(milestoneCopy);
				} else {
					arr.push(milestone)
				}
				phases.push(arr);
			} else {
				phases[counter].push(milestone);
			}
		},

		// divide milestones into pages
		definePages(phases, optionalPhases) {
			for (let phase of phases) {
				this.pages.push({
					phases: phase
				});
			}

			let index = this.pages.length - 1;
			this.pages[index].table = true;

			for (let i = 0; i < optionalPhases.length; i++) {
				if (this.pages[index]) {
					this.pages[index].optionalPhases = optionalPhases[i];
				} else this.pages.push({
					optionalPhases: optionalPhases[i]
				});
				index++;
			}
		}
	},
	mounted() {
		this.structureMilestones(this.milestones);
	}
}
</script>

<style lang="scss">
	.Milestones {
		display: grid;
		grid-template-columns: 65% 1fr 1fr;
		gap: 35px 5px;
		line-height: 15pt;

        &:not(:first-child) {
            margin-top: 30px;
        }

        &--noTime {
            grid-template-columns: 80% 1fr;

            .Header,
            .Milestone-Tree {
                grid-column: span 2;
            }
        }

        &:has(.Header) {
            grid-template-rows: min-content 1fr;
        }

		.Header {
			grid-column: span 3;
			display: grid;
			grid-template-columns: subgrid;
			overflow: hidden;

			span {
				font-size: 10pt;
				text-align: right;
				font-weight: 300;

				&:first-child {
					text-align: left;
				}
			}
		}

		.Page--continuing & {
			flex-grow: 1;
		}
	}

	.Milestones-Tree {
		grid-column: span 3;
		position: relative;
		display: grid;
		grid-template-columns: subgrid;
        grid-auto-rows: min-content;
        gap: 50px 5px;

		&::before {
			content: "";
			position: absolute;
			background-color: color(text-negative);
			width: 1px;
			height: 100%;
			top: 10px;
			left: 0;
		}

        .Milestones--noTime & {
            grid-column: span 2;
        }

		.Milestones--optional & {
			margin-top: 5px;

			&::before {
				content: none;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// Milestones.vue?4af313ee